<script>
export let params = {};

import app from '../web_feathers.js';
const {perms, email, userID, checkedToken,checkingToken} = app;

import {israelPhoneMobileNormalize, numberPrettify} from '../common_israel_mobiles.js';
import {findPlan, isFrozenPlanKey, planPickerOptions, publishedPlans, reactivationBill, reactivationOffer, canPickPlanOnReactivation, nextHotResetDate} from '../common_plans.js';
import {fetchAvailableAreaCodes, listAreaCodes, USA_PRICE, CANADA_PRICE} from '../common_usa_area_codes.js';
import {arrearsFor, arrearsHtml} from './arrears.js';
import Swal from 'sweetalert2';
const SwalBootstrap = Swal.mixin({
	customClass: {
		confirmButton: 'btn btn-success mx-2',
		cancelButton: 'btn btn-danger mx-2' //we lost our spacing between buttons for some reason - set spacing on both sides
		}
	,buttonsStyling: false
	,reverseButtons: true
	})

const SwalBootstrapReverseButtonColorCancel = Swal.mixin({
	customClass: {
		confirmButton: 'btn btn-danger mx-2',
		cancelButton: 'btn btn-success mx-2' //we lost our spacing between buttons for some reason - set spacing on both sides
		}
	,buttonsStyling: false
	,reverseButtons: true
	})

const SwalError = SwalBootstrap.mixin({
	icon: 'error'
	,allowOutsideClick: false
	});

let error;
let myLine = null;
let loading = false;

import { push } from 'svelte-spa-router';

import Fa from 'svelte-fa'
import { faCreditCard, faEdit, faMapMarkedAlt, faTools, faChevronRight, faSimCard, faTrash, faExchangeAlt, faInfo,faShoppingCart, faExclamationTriangle, faExclamation, faRedo, faPlay} from '@fortawesome/free-solid-svg-icons';


import {formatDistanceToNow, parseISO, format, isDate} from 'date-fns';

function FormatDateMonthDay(date){
	if(!isDate(date)) date = parseISO(date);
	return format(date, 'MMMM do');
	}

const SimActivations = app.service('sim_activations_user');

async function init(){
	loading=true;
	error=false;
	const result = await SimActivations.get(params.lineID,{query:{$joinEager:'hotmobile'}}).catch(e=>error=e.message).finally(()=>loading=false);
	if(error) return;
	myLine = result;
	}

init();

function showCountries(){
	SwalBootstrap.fire({
		title: 'List of additional countries - landlines only',
		html: '<div style="overflow-x:auto;">To call USA or Canada, dial 017-1 followed by the area code and number. Example: 017-1-718-....<br><br><table border=1 cellspacing=0>'+
			'<tr><td>Argentina</td><td>Australia</td><td>Austria</td><td>Belgium</td></tr>'+
		'<tr><td>China</td><td>Cyprus</td><td>Denmark</td><td>France</td></tr>'+
		'<tr><td>Germany</td><td>Greece</td><td>Hong Kong</td><td>Hungary</td></tr>'+
		'<tr><td>Ireland</td><td>Italy</td><td>Japan</td><td>Luxembourg</td></tr>'+
		'<tr><td>Malta</td><td>Netherlands</td><td>New Zealand</td><td>Norway</td></tr>'+
		'<tr><td>Poland</td><td>Portugal</td><td>Romania</td><td>Russia</td></tr>'+
		'<tr><td>Singapore</td><td>South Africa (country)</td><td>Spain</td><td>Sweden</td></tr>'+
		'<tr><td>Switzerland</td><td>Taiwan</td><td>Turkey</td><td>United Kingdom</td></tr>'+
		'<tr><td>Vatican</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>'+
		'</table></div>'
		})
	}

import SimHot from '../common_sim_hot.js';
function simSwap(){
	return SwalBootstrap.fire({
		title: 'SIM Swap',
		input: 'text',
		html: 'This will switch the active SIM card for your phone right now.<br>Please enter the 19-digit number printed on the SIM pack - OR - the 12-digit number printed on the actual SIM card (begins with 899 or 104, 105, or 194).',
		inputPlaceholder: 'SIM card number',
		//inputLabel: 'SIM Card',
		//inputValue: inputValue,
		showCancelButton: true,
		inputAttributes: {type:'tel', maxlength:19},//number input on mobile
		inputValidator: (value) => {
			const sim_info = SimHot(value);
			if(!value) return 'Please enter the SIM number'
			if(myLine.sim==sim_info.long) return 'This is already your active SIM card.';
			if(!sim_info.isValid) return 'Invalid SIM Card Number';
			if(value!=sim_info.long) value = sim_info.long;
			},

		showLoaderOnConfirm: true,
		allowOutsideClick: () => !Swal.isLoading(),
		allowEscapeKey: () => !Swal.isLoading(),
		preConfirm: (newSIM)=> SimActivations.patch(myLine.id,{sim:newSIM})
		})
	.then(function(result){
		if(!result.isConfirmed) return;
		myLine=result.value;//update our infomation
		SwalBootstrap.fire({
			title: 'SIM Card Swapped',
			html: 'Your SIM card has been swapped to '+myLine.sim+'<br><br>If you have already inserted your SIM card into your phone, you must restart your phone in order to pick up service.',
			icon: 'success',
			allowOutsideClick: false
			});
		})
	.catch(function(error){
		SwalError.fire({title:error.message});
		});
	}

function editName(){
	return SwalBootstrap.fire({
		title: 'Change Account Name',
		input: 'text',
		text:'Set the name of the account owner or nickname to identify this account.',
		//inputLabel: 'SIM Card',
		inputValue: myLine.Customer_Name,
		showCancelButton: true,
		inputValidator: (value) => {
			if(!value) return 'Please enter a value'
			if(value==myLine.Customer_Name) return 'This is already the account name';
			},

		showLoaderOnConfirm: true,
		allowOutsideClick: () => !Swal.isLoading(),
		allowEscapeKey: () => !Swal.isLoading(),
		preConfirm: (name)=> SimActivations.patch(myLine.id,{Customer_Name:name})
		})
	.then(function(result){
		if(!result.isConfirmed) return;
		myLine=result.value;//update our infomation
		SwalBootstrap.fire({
			title: 'Name Updated',
			text: 'The name for this line has been updated to: '+myLine.Customer_Name,
			icon: 'success',
			});
		})
	.catch(function(error){
		SwalError.fire({title:error.message});
		});
	}
	
//The switch offer is every published plan but kosher, which is picked at signup and never switched to
//or from (a kosher line has no Change Plan button, and the server refuses it). The picker adds the
//customer's own plan when it is not in that list (legacy), marks it current at the price they really
//pay, and disables OK while it is selected.
//A frozen line is quoted at the price it would come back at, not its ₪10 freeze price.
function planPicker(){
	var offered = publishedPlans().filter(p => !p.kosher);
	var currentBill = isFrozenPlanKey(myLine.plan) ? reactivationBill(myLine) : myLine.bill;
	return planPickerOptions(offered, {currentKey: myLine.plan, currentBill});
	}
async function changePlan(){
	//Changing the plan of a frozen line is reactivating it onto that plan (the server does both).
	if(isFrozenPlanKey(myLine.plan)) {
		if(!canPickPlanOnReactivation(myLine)) return reactivate();//this month is paid: it comes back as it was
		const picked = await SwalBootstrap.fire({
			title: 'Reactivate on a New Plan',
			text: 'Your line is frozen. Choose the plan to reactivate it on.',
			...planPicker(),
			showCancelButton: true,
			});
		if(picked.value) reactivate(picked.value);
		return;
		}

	const result = await SwalBootstrap.fire({
		title: 'Select New Plan',
		text: 'You currently pay '+myLine.bill + ' shekel per month for '+myLine.dataGB+'gb of data',
		...planPicker(),
		showCancelButton: true,
		})

	const newPlanChoice=result.value;

	if (!newPlanChoice) return;
	
	var newPlanDetails = findPlan(newPlanChoice);
	console.log(newPlanDetails);

	if(newPlanDetails.fiveG){
		let confirm5G = await SwalBootstrap.fire({
			title: '5G Plan Information',
			html: '5G speed is not available everywhere and requires a phone that supports it.<br>Are you sure you want to choose this plan?',
			icon: 'warning',
			showCancelButton: true,
			allowOutsideClick: () => !Swal.isLoading(),
			allowEscapeKey: () => !Swal.isLoading(),
			})
		if(!confirm5G.isConfirmed) return;
		}

	var priceDifference = newPlanDetails.bill - myLine.bill;

	//A change the customer pays extra for goes to Hot now. Anything else waits for Hot's monthly reset:
	//we do not refund, so they keep what they paid for (sim_activations_user.hooks.js holds it).
	var held = priceDifference<=0;
	var resetDay = FormatDateMonthDay(nextHotResetDate());
	var confirmNotes = [];
	if(priceDifference<0) confirmNotes.push("Please Note: You keep your current plan until the monthly data reset on "+resetDay+", when the new plan starts.<br>The lower price starts with your next bill on "+FormatDateMonthDay(myLine.nextBill)+". The current month is not refunded.");
	if(priceDifference==0) confirmNotes.push("Please Note: The new plan starts at the monthly data reset on "+resetDay+". The price stays the same.");
	if(priceDifference>0) confirmNotes.push("Note: You will be charged "+priceDifference+" shekel right now to upgrade to the "+newPlanDetails.label+" plan.");
	if(!held && newPlanDetails.dataGB>myLine.dataGB) confirmNotes.push("Your data allowance will be increased to "+newPlanDetails.dataGB+"gb in 1-3 business days.");

	await SwalBootstrap.fire({
		title: 'Are you sure?',
		icon: 'warning',
		html: confirmNotes.join('\n<br><br>'),
		//confirmButtonColor: '#3085d6',
		confirmButtonText: 'Change My Plan',
		showCancelButton: true,
		//cancelButtonColor: '#d33',

		showLoaderOnConfirm: true,
		allowOutsideClick: () => !Swal.isLoading(),
		allowEscapeKey: () => !Swal.isLoading(),
		preConfirm: ()=> SimActivations.patch(myLine.id,{plan:newPlanDetails.key})//always write the canonical key
		})
	.then(function(result){
		if(!result.isConfirmed) return;
		myLine=result.value;//update our infomation
		SwalBootstrap.fire({
			title: 'Plan Updated',
			html: 'The plan has been updated to '+newPlanDetails.label + '.<br><small>' + (held ? 'The new plan starts at the monthly data reset on '+resetDay+'.' : 'It may take 1-3 business days to see the new data allowance.') + '</small>',
			icon: 'success',
			allowOutsideClick: false
			});
		})
	.catch(function(error){
		if(error.message.startsWith('Tranzila 00')) SwalError.fire({title:'Credit Card Payment Failed - perhaps you need to update your credit card?'});
		else SwalError.fire({title:error.message});
		});

	}

async function addVirtualNumber(){
	if(isFrozenPlanKey(myLine.plan)) {
		return SwalBootstrap.fire({
			title: 'Cannot Alter Frozen Line',
			text: 'You cannot add a virtual number to a frozen line - reactivate it first.',
			icon: 'error',
			})
		}

	/*const numbersInAccount = await app.service('forwarding-number').get(myLine.id);
	console.log(numbersInAccount);
	return;*/

	const availableAreaCodes = await fetchAvailableAreaCodes();

	const submitLocation = (location)=> SimActivations.patch(myLine.id,{addVirtualNumber: true, location});
	function showOutcome(result){
		if(!result.isConfirmed) return;
		myLine=result.value;//update our infomation
		if(myLine.usa_number) return SwalBootstrap.fire({
			title: 'Virtual Number Set Up!',
			html: 'Your new virtual number is <b>'+ numberPrettify(myLine.usa_number) +'</b> and is now active.',
			icon: 'success',
			allowOutsideClick: false
			});
		else SwalBootstrap.fire({
			title: 'Virtual Number Ordered!',
			html: 'We\'ll notify you as soon as your new virtual number is set up.',
			icon: 'success',
			allowOutsideClick: false
			});
		}

	const question = {
		title: 'Add Virtual Number',
		html: 'USA numbers cost $'+USA_PRICE+'/month, Canada $'+CANADA_PRICE+'/month — billed by BestFone.',
		//inputLabel
		showCancelButton: true,
		confirmButtonText: 'Add this number now!',

		showLoaderOnConfirm: true,
		allowOutsideClick: () => !Swal.isLoading(),
		allowEscapeKey: () => !Swal.isLoading(),
		}
	if(availableAreaCodes){
		question.html+='<br>Choose any of these area codes for instant activation.';
		question.input = 'select';
		//a Map keeps the USA-first order - a plain object would re-sort the numeric "347" keys
		question.inputOptions = new Map(listAreaCodes(availableAreaCodes).map(s=>[s.code, s.label]));
		question.inputOptions.set('other', 'Other location… (manual setup, 12-48 hours)');
		question.inputPlaceholder = 'Choose a location';
		question.inputValidator = (value) => {
			if(!value) return 'Please choose a location';
			}
		question.didOpen = () => {//free-text field, revealed inline when "Other" is selected
			const select = Swal.getInput();
			select.insertAdjacentHTML('afterend', '<input id="swal-other-location" class="swal2-input" placeholder="City or area code" style="display:none">');
			select.addEventListener('change', () => {
				document.getElementById('swal-other-location').style.display = (select.value=='other') ? '' : 'none';
				});
			}
		question.preConfirm = (choice) => {//keys are the bare area codes
			if(choice!='other') return submitLocation(choice);
			const other = document.getElementById('swal-other-location').value.trim();
			if(!other) { Swal.showValidationMessage('Please enter a city or area code'); return false; }
			return submitLocation(other);
			}
		}
	else {//no live area code list loaded
		question.preConfirm = (choice)=> submitLocation(choice);
		question.input = 'text';
		question.html += `<br><div class="text-left"><b>Choose a Location</b> (if you don't specify, we will set up a New York number)
			<ul class="ml-4 mt-0 text-left">
				<li><small>NY, NJ, CA (you will receive your number immediately or within 6 hours)</small></li>
				<li><small>Other Location: (you will receive your number within 12-48 hours)</small></li>
				<li><small>Canada, $17/month: specify area code (you will receive your number within 12-48 hours)</small></li>
			</ul></div>`;
		}

	await SwalBootstrap.fire(question)
	.then(showOutcome)
	.catch(function(error){
		SwalError.fire({title:error.message});
		});

	}

async function removeVirtualNumber(){
	if(isFrozenPlanKey(myLine.plan)) {
		return SwalBootstrap.fire({
			title: 'Cannot Alter Frozen Line',
			text: 'You cannot modify the virtual number on a frozen line',
			icon: 'error',
			})
		}

	return SwalBootstrapReverseButtonColorCancel.fire({
		title: 'Cancel Virtual Number?',
		html: `Are you sure you want to cancel your virtual number ${numberPrettify(myLine.usa_number)}?
				<br><small>It will remain active until the end of the billing cycle.</small>`,
		icon: 'warning',
		showCancelButton: true,
		//confirmButtonColor: '#3085d6',
		confirmButtonText: 'Cancel Virtual Number',
		//cancelButtonColor: '#d33',
		cancelButtonText: 'Keep My Number',

		showLoaderOnConfirm: true,
		allowOutsideClick: () => !Swal.isLoading(),
		allowEscapeKey: () => !Swal.isLoading(),
		preConfirm: ()=>SimActivations.patch(myLine.id,{action:'cancelVirtualNumber',date:'now'})
		})
	.then(function(result){
		if(!result.isConfirmed) return;
		myLine=result.value;//update our infomation
		if(myLine.message) return SwalBootstrap.fire({
			title: 'Virtual Number Cancelled',
			text: myLine.message,
			icon: 'success',
			allowOutsideClick: false
			});
		})
	.catch(function(error){
		SwalError.fire({title:error.message});
		});

	}

//chosenKey: the plan picked in Change Plan, or nothing to come back on the line's own plan.
async function reactivate(chosenKey){
	if(typeof chosenKey != 'string') chosenKey = undefined;//a button click passes the event
	//Quote exactly what the server will do (sim_activations_user.hooks.js 'reactivate', same
	//reactivationOffer): the plan it comes back on (a legacy 200gb line comes back as 5G 180gb) and the
	//grandfathered price where the freeze recorded one.
	var offer = reactivationOffer(myLine, chosenKey);
	if(offer.error) return SwalError.fire({title: offer.error});
	var newPlanDetails = offer.plan;
	var reactivatePrice = offer.bill;
	var reactivateDataGB = newPlanDetails.dataGB;

	var confirmNotes = [];
	if(chosenKey) confirmNotes.push('Your line will be reactivated on the '+newPlanDetails.label+' plan.');

	if(myLine.paidCurrentCycleFullPrice) confirmNotes.push('Note: You will be charged '+reactivatePrice+' shekel on your next bill day which is '+FormatDateMonthDay(myLine.nextBill)+' (this is a monthly bill until cancelled).');
	else confirmNotes.push('Note: You will be charged '+reactivatePrice+' shekel right now to reactivate your line (this is a monthly bill until cancelled).');

	if(!myLine.kosher) confirmNotes.push('Your data allowance will be '+reactivateDataGB+'gb per month (resets on the 13th).');

	if(myLine.usa_number) confirmNotes.push('Your Virtual Number '+numberPrettify(myLine.usa_number) +' will also be charged and reactivated.');

	await SwalBootstrap.fire({
		title: 'Re-Activate Now?',
		icon: 'warning',
		html: confirmNotes.join('\n<br><br>'),
		//confirmButtonColor: '#3085d6',
		confirmButtonText: 'Yes, Re-Activate Now',
		showCancelButton: true,
		cancelButtonText:'Later',
		//cancelButtonColor: '#d33',

		showLoaderOnConfirm: true,
		allowOutsideClick: () => !Swal.isLoading(),
		allowEscapeKey: () => !Swal.isLoading(),
		preConfirm: ()=> SimActivations.patch(myLine.id,{action:'reactivate',date:'now', plan: chosenKey && newPlanDetails.key})
		})
	.then(function(result){
		if(!result.isConfirmed) return;
		myLine=result.value;//update our infomation
		let text = 'If you have already inserted your SIM card into your phone, you must restart your phone in order to pick up service.';
		if(myLine.message) {
			SwalBootstrap.fire({
				title: 'Re-Activation Started',
				text: myLine.message,
				icon: 'warning',
				allowOutsideClick: false
				})
			}
		else SwalBootstrap.fire({
			title: 'Re-Activation Successful!',
			text: text,
			icon: 'success',
			allowOutsideClick: false
			})
		})
	.catch(function(error){
		if(error.message.startsWith('Tranzila 00')) SwalError.fire({title:'Credit Card Payment Failed - perhaps you need to update your credit card?'});
		else SwalError.fire({title:error.message});
		});
	}

async function cancelOrFreeze(){
	var freezePrice = '10 shekel';
	if(myLine.usa_number) freezePrice='$5';

	if(isFrozenPlanKey(myLine.plan)) {
		var text = [
			'Your phone number '+israelPhoneMobileNormalize(myLine.israel_number)
			,'is currently reserved for future use at a cost of '+freezePrice + ' per month.'
			,'<br>Do you want to cancel? (You can keep the SIM card for another future activation.)'
			];
		if(myLine.usa_number) text[0]+=' and virtual number '+numberPrettify(myLine.usa_number)

		return SwalBootstrapReverseButtonColorCancel.fire({
			title: 'Cancel Frozen Line?',
			html: text.join(' '),
			icon: 'warning',
			showCancelButton: true,
			//confirmButtonColor: '#3085d6',
			confirmButtonText: 'Cancel My Number',
			//cancelButtonColor: '#d33',
			cancelButtonText: 'Keep My Number',

			showLoaderOnConfirm: true,
			allowOutsideClick: () => !Swal.isLoading(),
			allowEscapeKey: () => !Swal.isLoading(),
			preConfirm: ()=>SimActivations.patch(myLine.id,{action:'cancel',date:'now'})
			})
		.then(function(result){
			if(!result.isConfirmed) return;
			myLine=result.value;//update our infomation
			SwalBootstrap.fire({
				title: 'Line Cancelled',
				html: 'Your line has been cancelled, you will not be billed again.<br>You can keep the SIM card for another future activation.<br>Thank you for using FreedomHot!',
				icon: 'success',
				allowOutsideClick: false
				})
			})
		.catch(function(error){
			SwalError.fire({title:error.message});
			});
		}

		
	let swalOptions = {
		title: 'Cancel for Good or Freeze?',
		input: 'radio',
		confirmButtonText: 'Continue',
		inputOptions: {Cancel:'<b>Cancel my account</b> for good. You will not be charged again.<br><small>(You can keep the SIM card for another future activation.)</small><br><br>'},
		showCancelButton: true,
		cancelButtonText: 'Go Back',
		inputValidator: (value) => {
			if(!value) return 'Please enter a value'
			}
		}
	if(myLine.usa_number) {
		swalOptions.inputOptions['Freeze']='<b>Reserve both my numbers</b> for a total of $5 per month.<br><small>You will be charged $5 on your next bill day.</small><br><br>';
		swalOptions.inputOptions['Freeze Only Israel']='<b>Reserve my Israel number only</b> for 10 shekels per month.<br><small>You will be charged 10 shekels on your next bill day which is '+FormatDateMonthDay(myLine.nextBill)+'.</small>';
		}
	else swalOptions.inputOptions['Freeze']='<b>Reserve my number</b> for 10 shekels per month.<br><small>You will be charged 10 shekels on your next bill day which is '+FormatDateMonthDay(myLine.nextBill)+'.</small>';

	//Freeze:'Yes, reserve my number'+(myLine.usa_number ? 's':'')+' ('+freezePrice+' per month)',

	
	const cancelOrFreezeChoice = await SwalBootstrapReverseButtonColorCancel.fire(swalOptions);

	const action = cancelOrFreezeChoice.value; //'freeze' or 'cancel' or 'Freeze Only Israel'
	if (!action) return;

	var text = [
			'This will immediately:<br>',
			'-' + action.toLowerCase().split(' ')[0] + ' phone number '+israelPhoneMobileNormalize(myLine.israel_number)
			];
	if(myLine.usa_number) {
		if(action=='Freeze Only Israel') text.push('<br>-cancel virtual number '+numberPrettify(myLine.usa_number));
		else text.push('<br>-'+action.toLowerCase()+' virtual number '+numberPrettify(myLine.usa_number));
		}
	let swalOptionsConfirm = {
		title: 'Are you sure you want to '+action.toLowerCase()+'?',
		html: text.join(' '),
		icon: 'warning',
		showCancelButton: true,
		confirmButtonText: 'Yes, '+action + ' My Line',
		cancelButtonText: 'Go Back',

		showLoaderOnConfirm: true,
		allowOutsideClick: () => !Swal.isLoading(),
		allowEscapeKey: () => !Swal.isLoading(),
		preConfirm: ()=> SimActivations.patch(myLine.id,{action:action.toLowerCase(),date:'now'})
		};
	if(action=='Freeze Only Israel') {
		swalOptionsConfirm.title= 'Are you sure you want to freeze your Israel number and cancel the virtual number?';
		swalOptionsConfirm.confirmButtonText = 'Yes, Freeze My Israel Line';
		}
	
	await SwalBootstrapReverseButtonColorCancel.fire(swalOptionsConfirm)
	.then(function(result){
		if(!result.isConfirmed) return;
		myLine=result.value;//update our infomation
		
		if(action=='Freeze Only Israel') freezePrice='10 shekel';//@TODO this is not DRY and the wrong place to put it?? Maybe check the result of `bill` which is 10 for the Isreali one or otherwise 0 and then we need the USA price? return the value from the server?

		let html = 'Your line has been cancelled, and you will not be billed again.<br>You can keep the SIM card for another future activation.<br>Thank you for using FreedomHot!';
		if(action=='Freeze') html='Your line has been reserved for future use at a cost of '+freezePrice+' per month.<br>Please return to this page to reactivate your line in the future.';
		else if(action=='Freeze Only Israel') html='Your virtual number has been cancelled, and your Israel mobile line has been reserved for future use at a cost of '+freezePrice+' per month.<br>Please return to this page to reactivate your line in the future.';
		SwalBootstrap.fire({
			title: action + ' Successful!',
			html: html,
			icon: 'success',
			allowOutsideClick: false
			})
		})
	.catch(function(error){
		SwalError.fire({title:error.message});
		});

	}

async function rebill(){
	//The retry charges every line on this card, every month owed (#114) - fetch them so we can say how much.
	const withLinked = await SimActivations.get(myLine.id,{query:{showLinked:true}}).catch(()=>myLine);
	const sameCard = (withLinked.linked||[]).filter(line=>line.TranzilaTK && line.TranzilaTK==myLine.TranzilaTK);
	const arrears = arrearsFor([withLinked, ...sameCard]);

	let html = `xxxx${myLine.TranzilaTK?.slice(-4)}, expiry: ${prettyPrintExpiry(myLine.cc_expiry)}`;
	if(arrears.total>0) html += `<br><br><b>This charges ₪${arrears.total} right away.</b><br>` + arrearsHtml(arrears);

	return SwalBootstrap.fire({
		title: arrears.total>0 ? `Retry same credit card for ₪${arrears.total}?` : 'Retry same credit card?',
		html,
		icon: 'question',
		showDenyButton: true,
		//confirmButtonColor: '#3085d6',
		confirmButtonText: arrears.total>0 ? `Retry & pay ₪${arrears.total}` : 'Retry Credit Card',
		//cancelButtonColor: '#d33',
		denyButtonText: 'Enter New Card',
		customClass: {
			confirmButton: 'btn btn-success mx-2',
			denyButton: 'btn btn-primary mx-2'
			},
		showLoaderOnConfirm: true,
		allowOutsideClick: () => !Swal.isLoading(),
		allowEscapeKey: () => !Swal.isLoading(),
		preConfirm: ()=>SimActivations.patch(myLine.id,{billing_update:true,chargeAllSameToken:true,billTotalDue:true})
		})
	.then(function(result){
		if(result.isDenied) return push('/update_credit_card/'+myLine.id);
		
		if(result.isDismissed) return;

		myLine=result.value;//update our infomation

		let html = 'The credit card charge now went though. Thank you!';
		if(myLine.message) html+= '\n<br>' + myLine.message;
		if(myLine.messageBestfone) html+= '\n<br>' + myLine.messageBestfone;//I don't think this will ever be activate here
		SwalBootstrap.fire({
			title: 'Billing Successful',
			html: html,
			icon: 'success',
			allowOutsideClick: false
			})
		})
	.catch(function(error){
		if(error.message.startsWith('Tranzila 00')) SwalError.fire({title:'Credit Card Payment Failed - perhaps you need to update your credit card?'});
		else SwalError.fire({title:error.message});
		});
	}


function status(line){
	if(line.active==false) return 'Cancelled';
	if(isFrozenPlanKey(line.plan)) return 'Frozen';
	else return 'Active';
	}

function prettyPrintExpiry(date){
	if(!date) return '';
	let year=0;
	let month=0;
	if(date.length==6) {
		month = parseInt(date.substr(0,2));
		year = parseInt(date.substr(2,4));
		}
	if(date.length==4) {
		month = parseInt(date.substr(0,2));
		year = 2000+parseInt(date.substr(2,2));
		}
	if(year && month) return `${month}/${year}`;
	return date;
	}

</script>

<style>
:global(.swal2-radio) {/*vertically align radio choices*/
	display: grid !important;
	flex: 0 0 auto; /*via https://stackoverflow.com/a/43230912/1278519*/
	}

:global(.swal2-radio > label) { /*via https://stackoverflow.com/a/43230912/1278519*/
	display: flex;
	line-height: 1.1;
	/*display: table-cell; will make it wrap the text*/ 
	}
:global(.swal2-radio input[type="radio"]) {
	vertical-align: top;
	margin-top: 4px;
	/*height: 100%; this breaks seeing the buttons?? worked in chrome on my computer & android*/ 
	}
</style>

<div class="container">

<div class="row">
	{#if error}
		<div class="alert alert-danger">
		{error}
		</div>
		{/if}
</div>

{#if myLine && !myLine.active}
<div class="row ff-dunbar title-2">
	<div class="col-12 text-center">
		{myLine.email}
		<br>{myLine.Customer_Name}
		<br><span style="text-decoration: line-through solid red 3px">{israelPhoneMobileNormalize(myLine.israel_number)}</span>
		<br>
	</div>
</div>
<br>
<div class="row justify-content-md-center">
	<div class="col-md-10 col-xs-12">
		<div class="alert alert-danger text-center"><Fa icon={faExclamationTriangle}/> This account has been cancelled and can't be modified.</div>
	</div>
</div>


{:else if myLine}
<div class="row ff-dunbar title-2">
	<div class="col-12 text-center">
		{myLine.email}
		<br>{myLine.Customer_Name} <span on:click={editName}><Fa icon={faEdit}/></span>
		<br>{israelPhoneMobileNormalize(myLine.israel_number)}
		{#if myLine.sim}
			<br>SIM Number ending in: {myLine.sim.slice(-4)}
		{/if}
		<br>
	</div>
</div>

<div class="row ff-dunbar title-3">
	<div class="col-12 text-center">
	{#if myLine.usa_number}
		Virtual Number: {numberPrettify(myLine.usa_number)}

		&nbsp;<button on:click={removeVirtualNumber} class="btn btn-sm btn-danger" disabled={loading}><Fa icon={faTrash}/> Cancel Virtual Number</button>

	{:else if !isFrozenPlanKey(myLine.plan)}
		<button class="btn btn-sm btn-primary mt-3" on:click={addVirtualNumber}>Buy Virtual Number <Fa icon={faChevronRight} /></button>
	{/if}
	<br>
	<br>
	</div>
	</div>

{#if isFrozenPlanKey(myLine.plan)}
	<div class="row justify-content-md-center">
		<div class="col-md-10 col-xs-12">
			<div class="alert alert-warning text-center"><Fa icon={faExclamation}/> This account is currently frozen. Please reactivate when you want service. &nbsp;&nbsp;<button class="btn btn-sm btn-success mb-1" on:click={reactivate}><Fa icon={faPlay}/> Re-Activate Line <Fa icon={faChevronRight}/></button>
			</div>
		</div>
	</div>

{:else}
<div class="row ff-dunbar title-3 justify-content-md-center">
	<table border=0 style="border-spacing: 10px;">
	<tr><td class="text-right" style="padding-right: 5px;"><img src="/image/tick.svg" border=0 width=18 height=18 alt="checked"></td>
		<td class="text-left">Unlimited Calls &amp; Texts to Israeli phone numbers
		</td></tr>
	<tr><td class="text-right" style="padding-right: 5px;"><img src="/image/tick.svg" border=0 width=18 height=18 alt="checked"></td>
		<td class="text-left">Unlimited calls to USA and Canada - <small>dial 017</small> &nbsp;<img style="cursor:pointer" src="image/question-circle-o.png" on:click={showCountries} border="0" width="14" height="16" alt="Click to list countries">
		</td></tr>
	<tr><td class="text-right" style="padding-right: 5px;"><img src="/image/tick.svg" border=0 width=18 height=18 alt="checked"></td>
		<td class="text-left">Voicemail - <small>To listen to voicemail, dial 151. Password is 1234*</small>
		</td></tr>
	</table>
	</div>
{/if}

<br>

<div class="row justify-content-md-center">
<div class="col-12 col-lg-10">
<div class="card">
	<div class="card-header">
		<Fa icon={faCreditCard} /> Billing Credit Card
	</div>
	<div class="card-body">
		<div class="row ff-dunbar title-3">
			<div class="col-5 text-right">
				Credit Card
				</div>
			<div class="col-7">
				xxxx{myLine.TranzilaTK?.slice(-4)}, {prettyPrintExpiry(myLine.cc_expiry)}
				</div>
			</div>
		<div class="row ff-dunbar title-3">
			<div class="col-5 text-right">
				Next Bill
				</div>
			<div class="col-7">
				{myLine.nextBill} <small>{myLine.nextBill && formatDistanceToNow(parseISO(myLine.nextBill),{addSuffix:true}) || ''}</small>
				</div>
			</div>
		<div class="row ff-dunbar title-3">
			<div class="col-5 text-right">
				Account Created
				</div>
			<div class="col-7">
				{myLine.createdAt?.split('T')[0]} <small>{myLine.createdAt && formatDistanceToNow(parseISO(myLine.createdAt),{addSuffix:true}) || ''}</small>
				</div>
			</div>

		<br>
		<div class="text-center">
			<!--<a class="btn btn-sm btn-primary" href="https://hotmobilenow.com/credit-card.html?phone={israelPhoneMobileNormalize(myLine.israel_number)}&purpose=Freedom+Hot+Account+only&name={myLine.Customer_Name}&email={myLine.email}" target="_blank"><Fa icon={faCreditCard} /> Update Credit Card With Support<Fa icon={faChevronRight}/></a>&nbsp;&nbsp;-->
			<a class="btn btn-sm btn-primary" href="#/update_credit_card/{myLine.id}"><Fa icon={faCreditCard} /> Update Credit Card <Fa icon={faChevronRight}/></a>
			</div>

			{#if myLine.billing_status!='ok'}
			<br>
			<div class="row justify-content-md-center">
				<div class="col-md-10 col-xs-12">
					<div class="alert alert-danger text-center">
						<Fa icon={faExclamationTriangle}/> <b>Billing Failed!</b> Please update your credit card.<br>
						You need to pay from {myLine.nextBill}. <button class="btn btn-sm btn-primary" on:click={rebill}>Retry Billing <Fa icon={faRedo}/></button>
					</div>
				</div>
			</div>
			{/if}


	</div>
	</div>
</div>
</div>

<br>
<div class="row justify-content-md-center">
	<div class="col-12 col-lg-10">
	<div class="card">
		<div class="card-header">
			<Fa icon={faInfo} /> Plan Details
		</div>
		<div class="card-body">
			<div class="row ff-dunbar title-3">
				<div class="col-5 text-right">
					Monthly fee
					</div>
				<div class="col-7">
					{#if myLine.bill}
						{myLine.bill} shekels
					{:else if myLine.bill==0 && isFrozenPlanKey(myLine.plan)}<!-- this is a guess based on what it will show in BestFone-->
						$5 dollars <small>(billed by BestFone)</small>
					{/if}
					</div>
				</div>


			{#if isFrozenPlanKey(myLine.plan)}
			<br>
			<div class="row justify-content-center">
				<button class="btn btn-sm btn-success mb-1" on:click={reactivate}><Fa icon={faPlay}/> Re-Activate Line <Fa icon={faChevronRight}/></button>&nbsp;&nbsp;
				{#if !myLine.kosher && canPickPlanOnReactivation(myLine)}
				<button class="btn btn-sm btn-primary mb-1" on:click={changePlan}><Fa icon={faExchangeAlt}/> Re-Activate on a Different Plan <Fa icon={faChevronRight}/></button>&nbsp;&nbsp;
				{/if}

				<button class="btn btn-sm btn-danger mb-1" on:click={cancelOrFreeze}><Fa icon={faTrash}/> Cancel Line <Fa icon={faChevronRight}/></button>
			</div>

			{:else}
			<div class="row ff-dunbar title-3">
				<div class="col-5 text-right">
					Current Plan
					</div>
				<div class="col-7">
					{myLine.plan} 
					</div>
				</div>


			{#if !myLine.kosher && myLine.hotmobile && myLine.hotmobile.DATA_USAGE_GB}
			<div class="row ff-dunbar title-3">
				<div class="col-5 text-right">
					Current Usage
					</div>
				<div class="col-7">
					{(+myLine.hotmobile?.DATA_USAGE_GB).toFixed(2)}gb* ({(myLine.hotmobile?.DATA_USAGE_GB/myLine.dataGB*100).toFixed(0)}%)
					</div>
				</div>
				{/if}

			<br>
			<div class="text-center">
				{#if !myLine.kosher}
					<button class="btn btn-sm btn-primary mb-1" on:click={changePlan}><Fa icon={faExchangeAlt}/> Change Plan <Fa icon={faChevronRight}/></button>&nbsp;&nbsp;
				{/if}
				<button class="btn btn-sm btn-danger mb-1" on:click={cancelOrFreeze}><Fa icon={faTrash}/> Cancel or Freeze Line <Fa icon={faChevronRight}/></button>
				</div>

			{#if !myLine.kosher && myLine.hotmobile && myLine.hotmobile.DATA_USAGE_GB}
				<br>
				<small>
					*This usage information is delayed by several days.<br>
					Check your live usage by sending a text message to 530 and in the message, write the word "data".<br>
					Data usage resets on the 13th of the month.
				</small>
				{/if}
			{/if}
		</div>
		</div>
	</div>
	</div>

	<br>

	<div class="row justify-content-md-center">
		<div class="col-12 col-lg-10">
		<div class="card">
			<div class="card-header">
				<Fa icon={faSimCard} /> SIM Card
			</div>
			<div class="card-body">
				<div class="row ff-dunbar title-3">
					<div class="col-5 text-right">
						Current SIM
						</div>
					<div class="col-7">
						{myLine.sim}
						</div>
					</div>
	
				<br>
				<div class="text-center">
					<a class="btn btn-sm btn-primary mb-1" href="https://freedomhot.com/sim-order.html" target="_blank"><Fa icon={faShoppingCart}/> Order Replacement SIM <Fa icon={faChevronRight}/></a>&nbsp;&nbsp;
					<button class="btn btn-sm btn-primary mb-1" on:click={simSwap} disabled={!myLine.active || isFrozenPlanKey(myLine.plan)}><Fa icon={faSimCard}/> SIM Swap <Fa icon={faChevronRight}/></button>
						{#if !myLine.active || isFrozenPlanKey(myLine.plan)}
							<br><small><i>You can't do a SIM swap until your line is active.</i></small>
						{/if}
					</div>
			</div>
			</div>
		</div>
		</div>

{:else if loading}

... loading

{:else}

Line not found.

{/if}


</div>